import React from "react";

const Footer = () => {
  
  function stop(e) {
    e.preventDefault()
  }
  return (
    <footer className="footer">
      <div className="ubicacion">
        <a href="/" onClick={stop}>Nuestros datos</a> | <a href="/" onClick={stop}>Términos y condiciones</a>|{" "}
        <a href="/" onClick={stop}>Política y privacidad</a> |<a href="/" onClick={stop}>Seleccionar país</a>{" "}
        | <a href="/" onClick={stop}>Uso del sitio</a>
      </div>
      <div className="small">
        <small>
          &#169; Perú 2022 Lorem ipsum dolor sit amet consectetur adipisicing elit.
          Ipsum, a?
        </small>
      </div>
    </footer>
  );
};

export default Footer;
